import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';


const MemberOfList = ({ teamId }) => {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await axiosInstance.get(`/api/user/teams/${teamId}`);
        if (Array.isArray(response.data)) {
          setTeams(response.data);
        } else {
          console.error('Expected an array, but received:', response.data);
        }
      } catch (error) {
        console.error("Error fetching teams", error);
      }
    };
    fetchTeams();
  }, [teamId]);

  if (teams.length === 0) return <div>No teams found</div>;

  return (
    <div>
      <h3>Member of</h3>
      <ul>
      {teams.map((team) => (
        <li key={team.id} className="team-item">
          {/* Circle */}
          <span
            className={`status-circle ${team.amount_in_cents > 0 ? 'green' : 'red'}`}
          ></span>

          {/* Team Link */}
          <a href={`/team/${team.id}`}>{team.name}</a>
        </li>
      ))}
    </ul>
    </div>
  );
};

export default MemberOfList;
